<template>
  <div class="w-100 no-gap">
    <EditSlide/>
    <!-- Navigation Menu -->
    <nav class="navbar-custom">
      <div class="navbar-container">
        <router-link
            v-for="(item, index) in navItems"
            :key="index"
            :to="item.route"
            class="navbar-item"
            :class="{ active: $route.path === item.route }"
        >
          <CIcon
              :name="item.iconName"
              class="navbar-icon"
              width="16"
              height="16"
          />
          {{ item.title }}
        </router-link>
      </div>
    </nav>

    <!-- Display subpage here -->
    <div class="content-area p-3">
      <router-view />
    </div>
  </div>
</template>

<script>
import '@/assets/css/slide.css'
import '@/assets/css/commit.css'
import { CIcon } from '@coreui/vue'
import EditSlide from '@/projects/views/admin/component/edit_slide.vue'

export default {
  name: 'admin_home',
  components: {
    CIcon, EditSlide
  },
  data() {
    return {
      navItems: [
        {
          title: 'LIST OF ALL SYSTEM USERS',
          iconName: 'cil-description',
          route: '/admin/admin_home/list_user'
        },
        {
          title: 'TIME SETTER',
          iconName: 'cil-clock',
          route: '/admin/admin_home/set_time'
        },
        {
          title: 'ADD ASSOCIATION',
          iconName: 'cil-user-plus',
          route: '/admin/admin_home/add_association'
        },
        {
          title: 'TOTAL ELECTION SCORE',
          iconName: 'cil-graph',
          route: '/admin/admin_home/score_candidate'
        },
        {
          title: 'EDIT PDPA',
          iconName: 'cil-color-border',
          route: '/admin/admin_home/edit_pdpa'
        }
      ]
    }
  }
}
</script>